<template>
<div>
<Dialog header="Soru Listesi Alanları" v-model:visible="show" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '90vw'}" :maximizable="true" :modal="true">

<div class="modal_area">
<TabView  v-model:activeIndex="activeIndex">
<TabPanel header="Bölümler">

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>
<template v-else>
	<template v-if="activeIndex==0">
		
<QuestionlistBatchEditModalTable :items="items" :itemtype="activeIndex"  @itemsSelected="itemsSelected"></QuestionlistBatchEditModalTable>
	</template>
</template>

</TabPanel>
<TabPanel header="Sorular">

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>
<template v-else>
	<template v-if="activeIndex==1">
		
<QuestionlistBatchEditModalTable :items="items" :itemtype="activeIndex"  @itemsSelected="itemsSelected"></QuestionlistBatchEditModalTable>	
	</template>
</template>
</TabPanel>
<TabPanel header="Seçenekler">

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>
<template v-else>
	<template v-if="activeIndex==2">
		
<QuestionlistBatchEditModalTable :items="items" :itemtype="activeIndex"  @itemsSelected="itemsSelected"></QuestionlistBatchEditModalTable>	
	</template>
</template>
</TabPanel>
<TabPanel header="Sütunlar">

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>
<template v-else>
	<template v-if="activeIndex==3">
		
<QuestionlistBatchEditModalTable :items="items" :itemtype="activeIndex" @itemsSelected="itemsSelected"></QuestionlistBatchEditModalTable>	
	</template>
</template>
</TabPanel>
</TabView>





</div>

</Dialog>
<Sidebar v-model:visible="showSidebar" :baseZIndex="10000" position="right" class="p-sidebar-md">
<div  style="min-height: 85vh;">
<div class="grid">

<!-- section -->	
<template v-if="activeIndex==0">
	<div class="col-12"><h3 class="text-primary mb-0 pb-0">Bölüm Özellikleri</h3></div>
	<div class="col-12"><hr></div>


	<div class="col-12 md:col-3"><h5 class="mt-1 mb-0">Bölüm Puanı</h5></div>
	<div class="col-12 md:col-9"><InputNumber  mode="decimal" :minFractionDigits="0" :maxFractionDigits="8"   v-model="points" class="w-full p-inputtext-sm"    @input="mutateItem('points','number',$event)" /></div>	

	<div class="col-12 md:col-3"><h5 class="mt-1 mb-0">Bölüm Görünürlüğü</h5></div>
	<div class="col-12 md:col-9"><Dropdown  v-model="show_section" :options="boolean_states" optionLabel="name" optionValue="code" class="w-full  p-inputtext-sm" @change="mutateItem('show_section','switch')" /></div>

	<div class="col-12 md:col-3"><h5 class="mt-1 mb-0">Alt Bölümleri Sayfa Olarak Göster</h5></div>
	<div class="col-12 md:col-9"><Dropdown  v-model="show_subsections_as_page" :options="boolean_states" optionLabel="name" optionValue="code" class="w-full  p-inputtext-sm" @change="mutateItem('show_subsections_as_page','switch')" /></div>
</template>
<!-- section -->

<!-- inputfield -->	
<template v-if="activeIndex==1">
	<div class="col-12"><h3 class="text-primary mb-0 pb-0">Soru Özellikleri</h3></div>
	<div class="col-12"><hr></div>


	<div class="col-12 md:col-3"><h5 class="mt-1 mb-0">Soru Puanı</h5></div>
	<div class="col-12 md:col-9"><InputNumber  mode="decimal" :minFractionDigits="0" :maxFractionDigits="8"   v-model="points" class="w-full p-inputtext-sm"   @input="mutateItem('points','number',$event)"  /></div>	

	<div class="col-12 md:col-3"><h5 class="mt-1 mb-0">Her İşaretleme Tam Puan</h5></div>
	<div class="col-12 md:col-9"><Dropdown  v-model="any_submission_full_points" :options="boolean_states" optionLabel="name" optionValue="code" class="w-full  p-inputtext-sm" @change="mutateItem('any_submission_full_points','switch')" /></div>

	<div class="col-12 md:col-3"><h5 class="mt-1 mb-0">Görünür</h5></div>
	<div class="col-12 md:col-9"><Dropdown  v-model="show_field" :options="boolean_states" optionLabel="name" optionValue="code" class="w-full  p-inputtext-sm" @change="mutateItem('show_field','switch')" /></div>

	<div class="col-12 md:col-3"><h5 class="mt-1 mb-0">Yatay Görünümlü Seçenekler</h5></div>
	<div class="col-12 md:col-9"><Dropdown  v-model="horizontal_select" :options="boolean_states" optionLabel="name" optionValue="code" class="w-full  p-inputtext-sm" @change="mutateItem('horizontal_select','switch')" /></div>

	<div class="col-12 md:col-3"><h5 class="mt-1 mb-0">Gerekli</h5></div>
	<div class="col-12 md:col-9"><Dropdown  v-model="is_required" :options="boolean_states" optionLabel="name" optionValue="code" class="w-full  p-inputtext-sm" @change="mutateItem('is_required','switch')" /></div>

	<div class="col-12 md:col-3"><h5 class="mt-1 mb-0">Aktif</h5></div>
	<div class="col-12 md:col-9"><Dropdown  v-model="active" :options="boolean_states" optionLabel="name" optionValue="code" class="w-full  p-inputtext-sm" @change="mutateItem('active','switch')" /></div>

	<div class="col-12 md:col-3"><h5 class="mt-1 mb-0">Boş Geçilebilir</h5></div>
	<div class="col-12 md:col-9"><Dropdown  v-model="is_nullable" :options="boolean_states" optionLabel="name" optionValue="code" class="w-full  p-inputtext-sm" @change="mutateItem('is_nullable','switch')" /></div>

	<div class="col-12 md:col-3"><h5 class="mt-1 mb-0">Boş Bırakma Nedeni Gerekli</h5></div>
	<div class="col-12 md:col-9"><Dropdown  v-model="is_null_reason_required" :options="boolean_states" optionLabel="name" optionValue="code" class="w-full  p-inputtext-sm" @change="mutateItem('is_null_reason_required','switch')" /></div>

	<div class="col-12 md:col-3"><h5 class="mt-1 mb-0">Kanıt Gerekli</h5></div>
	<div class="col-12 md:col-9"><Dropdown  v-model="is_evindence_required" :options="boolean_states" optionLabel="name" optionValue="code" class="w-full  p-inputtext-sm" @change="mutateItem('is_evindence_required','switch')" /></div>

	<div class="col-12 md:col-3"><h5 class="mt-1 mb-0">Kanıt İste</h5></div>
	<div class="col-12 md:col-9"><Dropdown  v-model="ask_for_evidence" :options="boolean_states" optionLabel="name" optionValue="code" class="w-full  p-inputtext-sm" @change="mutateItem('ask_for_evidence','switch')" /></div>

	<template v-if="is_evindence_required">
		<div class="col-12 md:col-3"><h5 class="mt-1 mb-0">Min Kanıt Sayısı</h5></div>
		<div class="col-12 md:col-9"><InputNumber  mode="decimal" :minFractionDigits="0" :maxFractionDigits="8"   v-model="min_evidences" class="w-full p-inputtext-sm"   @input="mutateItem('min_evidences','number',$event)"  /></div>	

		<div class="col-12 md:col-3"><h5 class="mt-1 mb-0">Max Kanıt Sayısı</h5></div>
		<div class="col-12 md:col-9"><InputNumber  mode="decimal" :minFractionDigits="0" :maxFractionDigits="8"   v-model="max_evidences" class="w-full p-inputtext-sm"   @input="mutateItem('max_evidences','number',$event)"  /></div>
		
	</template>
	

	<div class="col-12 md:col-3"><h5 class="mt-1 mb-0">Kayıt Notu İste</h5></div>
	<div class="col-12 md:col-9"><Dropdown  v-model="ask_for_submission_note" :options="boolean_states" optionLabel="name" optionValue="code" class="w-full  p-inputtext-sm" @change="mutateItem('ask_for_submission_note','switch')" /></div>

	<div class="col-12 md:col-3"><h5 class="mt-1 mb-0">Kayıt Notu Gerekli</h5></div>
	<div class="col-12 md:col-9"><Dropdown  v-model="submission_note_required" :options="boolean_states" optionLabel="name" optionValue="code" class="w-full  p-inputtext-sm" @change="mutateItem('submission_note_required','switch')" /></div>


	<div class="col-12 md:col-3"><h5 class="mt-1 mb-0">Min Değer</h5></div>
	<div class="col-12 md:col-9"><InputNumber  mode="decimal" :minFractionDigits="0" :maxFractionDigits="8"   v-model="min_value" class="w-full p-inputtext-sm"   @input="mutateItem('min_value','number',$event)"  /></div>	

	<div class="col-12 md:col-3"><h5 class="mt-1 mb-0">Max Değer</h5></div>
	<div class="col-12 md:col-9"><InputNumber  mode="decimal" :minFractionDigits="0" :maxFractionDigits="8"   v-model="max_value" class="w-full p-inputtext-sm"   @input="mutateItem('max_value','number',$event)"  /></div>	

	<template v-if="$store.state.questionlists.questionlist.type=='same_question_pattern'">

	<div class="col-12 md:col-3"><h5 class="mt-1 mb-0">Sınıfı</h5></div>
	<div class="col-12 md:col-9">
	
	<MultiSelect v-model="inputfieldclass_id" :options="inputfield_classes" optionLabel="name" optionValue="id" class="w-full  p-inputtext-sm"  @change="mutateItem('inputfieldclass_id','arr')"  />
	</div>
	</template>



</template>
<!-- inputfield -->

<!-- option -->	
<template v-if="activeIndex==2">
	<div class="col-12"><h3 class="text-primary mb-0 pb-0">Seçenek Özellikleri</h3></div>
	<div class="col-12"><hr></div>


	<div class="col-12 md:col-3"><h5 class="mt-1 mb-0">Seçenek Puanı</h5></div>
	<div class="col-12 md:col-9"><InputNumber  mode="decimal" :minFractionDigits="0" :maxFractionDigits="8"   v-model="points" class="w-full p-inputtext-sm"    @input="mutateItem('points','number',$event)" /></div>	
</template>
<!-- option -->

<!-- column -->	
<template v-if="activeIndex==3">
	<div class="col-12"><h3 class="text-primary mb-0 pb-0">Sütun Özellikleri</h3></div>
	<div class="col-12"><hr></div>
	

	<div class="col-12 md:col-3"><h5 class="mt-1 mb-0">Sütun Puanı</h5></div>
	<div class="col-12 md:col-9"><InputNumber  mode="decimal" :minFractionDigits="0" :maxFractionDigits="8"   v-model="points" class="w-full p-inputtext-sm"   @input="mutateItem('points','number',$event)"  /></div>	

	<div class="col-12 md:col-3"><h5 class="mt-1 mb-0">Sütun Gerekli</h5></div>
	<div class="col-12 md:col-9"><Dropdown  v-model="is_required" :options="boolean_states" optionLabel="name" optionValue="code" class="w-full  p-inputtext-sm" @change="mutateItem('is_required','switch')" /></div>

	<div class="col-12 md:col-3"><h5 class="mt-1 mb-0">Sütun Aktif</h5></div>
	<div class="col-12 md:col-9"><Dropdown  v-model="active" :options="boolean_states" optionLabel="name" optionValue="code" class="w-full  p-inputtext-sm" @change="mutateItem('active','switch')" /></div>



	<div class="col-12 md:col-3"><h5 class="mt-1 mb-0">Min Değer</h5></div>
	<div class="col-12 md:col-9"><InputNumber  mode="decimal" :minFractionDigits="0" :maxFractionDigits="8"   v-model="min_value" class="w-full p-inputtext-sm"   @input="mutateItem('min_value','number',$event)"  /></div>	

	<div class="col-12 md:col-3"><h5 class="mt-1 mb-0">Max Değer</h5></div>
	<div class="col-12 md:col-9"><InputNumber  mode="decimal" :minFractionDigits="0" :maxFractionDigits="8"   v-model="max_value" class="w-full p-inputtext-sm"   @input="mutateItem('max_value','number',$event)"  /></div>




</template>
<!-- column -->

</div>
</div>
<div class="">
  <div class="flex align-items-center justify-content-end mb-3">
            
            <Button :label="$store.state.languages.lang_phrases.iptal" icon="pi pi-times"  @click="hideModal" class=" p-button-danger p-button-outlined  p-button-sm" />
<Button :label="$store.state.languages.lang_phrases.kaydet" icon="pi pi-check"  @click="submit"  class=" p-button-primary p-button-outlined  p-button-sm ml-2"  :loading="submitting"/>
 </div>

</div>

</Sidebar>

</div>
</template>

<script>
import QuestionlistBatchEditModalTable from "./QuestionlistBatchEditModalTable"
export default {

  name: 'QuestionlistBatchEditModal',
  components:{QuestionlistBatchEditModalTable},
  data () {
    return {
    	show:false,
    	activeIndex:0,
    	items:[],
    	inputfield_classes:[],
    	loading:true,
    	showSidebar:false,
    	selecteditems:[],
    	points:null,
    	show_section:null,
    	show_subsections_as_page:null,
    	show_field:null,
    	any_submission_full_points:null,
    	is_required:null,
    	active:null,
    	is_nullable:null,
    	is_null_reason_required:null,
    	is_evindence_required:null,
    	ask_for_evidence:null,
    	ask_for_submission_note:null,
    	submission_note_required:null,
    	min_evidences:null,
    	max_evidences:null,
    	min_value:null,
    	max_value:null,
    	horizontal_select:null,
    	inputfieldclass_id:[],
    	submitting:false,
    	mutated_items:[],
    	boolean_states:[
    	{name:"Değişiklik yok",code:null},
    	{name:"Kapalı",code:false},
    	{name:"Açık",code:true},
    	]

    }
  },
  watch:{
  	showSidebar(newVal)
  	{
  		if(!newVal)
  		{
  			this.points=null;
	    	this.show_section=null;
	    	this.show_subsections_as_page=null;
	    	this.show_field=null;
	    	this.horizontal_select=null;
	    	this.inputfieldclass_id=[];
	    	this.any_submission_full_points=null;
	    	this.is_required=null;
	    	this.active=null;
	    	this.is_nullable=null;
	    	this.is_null_reason_required=null;
	    	this.is_evindence_required=null;
	    	this.ask_for_evidence=null;
	    	this.ask_for_submission_note=null;
	    	this.submission_note_required=null;
	    	this.min_evidences=null;
	    	this.max_evidences=null;
	    	this.min_value=null;
	    	this.max_value=null;
  		}
  	},
  	show(newVal)
  	{
  		if(!newVal)
  		{
  			this.activeIndex = 0
  		}
  		
  	},
  	activeIndex(newVal,oldVal)
  	{
  		this.items = []
  		this.selecteditems = []
  		this.mutated_items = []
  		if(newVal==0)
  		{
  			this.getSections()
  		}
  		if(newVal==1)
  		{
  			this.getQuestions()
  		}
  		if(newVal==2)
  		{
  			this.getOptions()
  		}
  		if(newVal==3)
  		{
  			this.getColumns()
  		}
  	}
  },
  methods:{
  	mutateItem(type,inputtype,event)
  	{
  		console.log(type)
  		console.log(inputtype)
  		console.log(this[type])
  		if(inputtype=="arr")
  		{
  			let ind = this.mutated_items.findIndex((item)=>{return item == type})
  			if(ind == -1)
	  		{
	  			this.mutated_items.push(type)
	  		}
	  		if(!this[type].length)
	  		{
	  			this.mutated_items = this.mutated_items.filter((item)=>{return item !== type})
	  		}

  		}
  		if(inputtype=="switch")
  		{
  			let ind = this.mutated_items.findIndex((item)=>{return item == type})
	  		if(ind == -1)
	  		{
	  			this.mutated_items.push(type)
	  		}
	  		else
	  		{
	  			this.mutated_items = this.mutated_items.filter((item)=>{return item !== type})
	  		}

  		}
  		if(inputtype=="number")
  		{
  			this[type] = event.value
  			let ind = this.mutated_items.findIndex((item)=>{return item == type})
  			if(ind == -1)
	  		{
	  			if(this[type] || this[type]===0)
	  			{
	  				this.mutated_items.push(type)
	  			}
	  			
	  		}
	  		else
	  		{
	  			if(!this[type])
	  			{
	  				this.mutated_items = this.mutated_items.filter((item)=>{return item !== type})
	  			}
	  		}
  		}

  		console.log(this[type])
  		
  	},
  	submit()
  	{
  		let formdata = new FormData()
  		let selecteditems = this.selecteditems.map((item)=>{return item.id})
  		console.log(this.mutated_items)
  		console.log(this.min_value)
  		//return false
  		formdata.append("selecteditems",JSON.stringify(selecteditems))
  		formdata.append("mutated_items",JSON.stringify(this.mutated_items))
  		formdata.append("activeindex",this.activeIndex)
  		formdata.append("points",this.points)
  		formdata.append("show_section",this.show_section)
  		formdata.append("show_subsections_as_page",this.show_subsections_as_page)
  		formdata.append("any_submission_full_points",this.any_submission_full_points)
  		formdata.append("show_field",this.show_field)
  		formdata.append("horizontal_select",this.horizontal_select)
  		formdata.append("inputfieldclass_id",JSON.stringify(this.inputfieldclass_id))

  		formdata.append("is_required",this.is_required)
  		formdata.append("active",this.active)
  		formdata.append("is_nullable",this.is_nullable)
  		formdata.append("is_null_reason_required",this.is_null_reason_required)
  		formdata.append("is_evindence_required",this.is_evindence_required)
  		formdata.append("ask_for_evidence",this.ask_for_evidence)
  		formdata.append("ask_for_submission_note",this.ask_for_submission_note)
  		formdata.append("submission_note_required",this.submission_note_required)
  		formdata.append("min_evidences",this.min_evidences)
  		formdata.append("max_evidences",this.max_evidences)
  		formdata.append("min_value",this.min_value)
  		formdata.append("max_value",this.max_value)
  		this.generalSubmission(formdata,"questionlists/batch_update_questionlist_items/"+this.$route.params.id,this.afterSubmit)
  	},
  	afterSubmit(response)
  	{
  		console.log(response.data)
  		this.showSidebar = false
  		this.selecteditems = []
  		this.mutated_items = []
  		this.show = false
  		this.points=null;
    	this.show_section=null;
    	this.show_subsections_as_page=null;
    	this.show_field=null;
    	this.horizontal_select=null;
    	this.inputfieldclass_id=[];

    	this.any_submission_full_points=null;
    	this.is_required=null;
    	this.active=null;
    	this.is_nullable=null;
    	this.is_null_reason_required=null;
    	this.is_evindence_required=null;
    	this.ask_for_evidence=null;
    	this.ask_for_submission_note=null;
    	this.submission_note_required=null;
    	this.min_evidences=null;
    	this.max_evidences=null;
    	this.min_value=null;
    	this.max_value=null;
    	this.activeIndex = 0
    	this.$emit("batchedited")
  	},
  	itemsSelected(data)
  	{
  		
  		console.log(data)
  		this.showSidebar = true
  		this.selecteditems = data
  	},
  	showModal()
  	{
  		this.show = true
  		this.getSections()
  	},
  	hideModal()
  	{
  		this.showSidebar = false
  		this.selecteditems = []
  		this.mutated_items = []
  		this.show = false
  		this.points=null;
    	this.show_section=null;
    	this.show_subsections_as_page=null;
    	this.show_field=null;
    	this.horizontal_select=null;
    	this.inputfieldclass_id=[];
    	
    	this.any_submission_full_points=null;
    	this.is_required=null;
    	this.active=null;
    	this.is_nullable=null;
    	this.is_null_reason_required=null;
    	this.is_evindence_required=null;
    	this.ask_for_evidence=null;
    	this.ask_for_submission_note=null;
    	this.submission_note_required=null;
    	this.min_evidences=null;
    	this.max_evidences=null;
    	this.min_value=null;
    	this.max_value=null;
    	this.activeIndex = 0
  	},
  	async getSections()
  	{
  		this.loading = await true

  		this.items = await this.generalApiGetWithoutLoader("questionlists/all_sections/"+this.$route.params.id)
  		await console.log(this.items)
  		this.loading = await false
  	},
  	async getQuestions()
  	{
  		this.loading = await true
  		this.items = await this.generalApiGetWithoutLoader("questionlists/all_inputfields/"+this.$route.params.id)
  		this.inputfield_classes = await this.generalApiGetWithoutLoader("inputfieldclasses/"+this.$route.params.id)
  		
  		
  		await console.log(this.items)
  		this.loading = await false
  	},
  	async getOptions()
  	{
  		this.loading = await true
  		let items = await this.generalApiGetWithoutLoader("questionlists/all_inputfield_options/"+this.$route.params.id)
  		items = await items.filter((item)=>{
  			return item.inputfield.status === 1
  		})
  		this.items = await items
  		await console.log(this.items)
  		this.loading = await false
  	},
  	async getColumns()
  	{
  		this.loading = await true
  		let items = await this.generalApiGetWithoutLoader("questionlists/all_inputfield_columns/"+this.$route.params.id)

  		items = await items.filter((item)=>{

  			return item.inputfield.status == 1
  		})
  		this.items = await items
  		await console.log(this.items)
  		this.loading = await false
  	},
  }
}
</script>

<style lang="css" scoped>
</style>